// initData в URL — учётные данные на час (tech/08 §2, Т-К-20). Клиент читает `#tgWebAppData=…` сам
// и СРАЗУ стирает фрагмент — до инициализации отчётов об ошибках и аналитики.

// telegram-web-app.js грузится async и сам читает фрагмент (tgWebAppData, tgWebAppVersion, tgWebAppPlatform…). Если
// бандл успел стереть его раньше, WebApp остаётся без initData (getWebApp() → null) и с версией 6.0 — так было при
// запуске кнопкой «Open» в живом Telegram Web: аналитика tma_web без версии, openInvoice бросал исключение. Поэтому
// перед стиранием кладём параметры туда, откуда скрипт Telegram берёт их сам, когда фрагмента нет:
// sessionStorage['__telegram__initParams'] (telegram-web-app.js, WebView: initParams ← storedParams).
const TG_INIT_PARAMS = '__telegram__initParams';

export function takeInitDataFromLocation(
  loc: Pick<Location, 'hash' | 'pathname' | 'search'> = location,
  hist: Pick<History, 'replaceState'> = history,
  store: Pick<Storage, 'getItem' | 'setItem'> | null = typeof sessionStorage === 'undefined' ? null : sessionStorage,
): string | null {
  const hash = loc.hash.startsWith('#') ? loc.hash.slice(1) : loc.hash;
  const params = new URLSearchParams(hash);
  const raw = params.get('tgWebAppData');
  if (raw !== null) {
    try {
      const saved = JSON.parse(store?.getItem(TG_INIT_PARAMS) ?? 'null') as Record<string, string> | null;
      const merged: Record<string, string> = { ...(saved ?? {}) };
      for (const [k, v] of params) if (k.startsWith('tgWebApp')) merged[k] = v;
      store?.setItem(TG_INIT_PARAMS, JSON.stringify(merged));
    } catch { /* нет sessionStorage — скрипт Telegram прочтёт фрагмент, если успел */ }
    hist.replaceState(null, '', loc.pathname + loc.search);
  }
  return raw;
}

/** Фильтр для отчётов об ошибках и аналитики: вырезать initData из любых строк (tech/08 §2). */
export function scrubInitData(s: string): string {
  return s.replace(/(tgWebAppData|initData)=[^&#\s]*/g, '$1=[скрыто]');
}
